import './polyfills'
import './amplify'
import './croppa'
import './vue2-filters'
import './fincraft'
import './vue-circle-slider'
import './vue-currency-field'
import './vue-full-page'
import './iefixes'
import './vue-toasted'

export default {
}
